export enum RouteNames {
  // Unauthorized
  signin = '/signin',
  siCompany = '/signin',

  // Authorized
  pinIn = '/page/pinin',
  sandbox = '/page/sandbox',
  debugLog = '/page/debuglog',
  dashboard = '/page/dashboard',
  contactSearch = '/page/contactsearch',
  contactDetail = '/page/contactdetail',
  contactAddEdit = '/page/contactaddedit',
  jobList = '/page/jobs',
  clockingDetails = '/page/clockingdetails',
  adhocClocking = '/page/adhocclocking',
  settings = '/page/settings',
  autoSync = '/page/sync',
  about = '/page/about',
  profile = '/page/profile',
  demo = '/page/demo',
}
